'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'hub-http/helpers/params';
import { isEmpty } from '../utils/object';
import Account from 'hub-pickers-lib/Accounts/records/Account';
import { redirectLink } from '../utils/links';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class SimpleHubPickerRow extends Component {
  constructor(...args) {
    super(...args);
    this.getRedirectUrl = () => {
      const {
        redirectTo,
        query,
        account: {
          id
        }
      } = this.props;
      let redirectUrl = redirectTo(id);
      if (!isEmpty(query)) {
        redirectUrl += `${redirectUrl.indexOf('?') === -1 ? '?' : '&'}${stringify(query)}`;
      }
      return redirectUrl;
    };
    this.handleRowClick = e => {
      if (e.metaKey) {
        window.open(this.getRedirectUrl());
      } else {
        window.location = this.getRedirectUrl();
      }
    };
    this.onOpenButtonClick = e => {
      window.open(this.getRedirectUrl());
      e.stopPropagation();
    };
  }
  render() {
    const {
      account: {
        accountName,
        domain,
        id
      }
    } = this.props;
    return /*#__PURE__*/_jsxs("tr", {
      onClick: this.handleRowClick,
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx("a", {
          href: this.getRedirectUrl(),
          children: /*#__PURE__*/_jsx(UITruncateString, {
            children: accountName
          })
        })
      }), /*#__PURE__*/_jsxs("td", {
        className: "domain",
        children: [/*#__PURE__*/_jsx(UITruncateString, {
          children: domain
        }), /*#__PURE__*/_jsx("span", {
          className: "subtext",
          children: id
        })]
      })]
    }, accountName);
  }
}
SimpleHubPickerRow.propTypes = {
  account: PropTypes.instanceOf(Account).isRequired,
  redirectTo: redirectLink.isRequired,
  query: PropTypes.object
};
export default SimpleHubPickerRow;